<template>
  <div style="color: whitesmoke">
    <div
      style="
        height: 45px;
        line-height: 45px;
        background: #2c2d31;
        color: #e6e6e6;
      "
    >
      <span
        v-html="text.title"
        style="margin-left: 10px; font-size: 15px"
      ></span>
    </div>
    <p class="container" style="margin-top: 10px" v-html="text.text"></p>
  </div>
</template>

<script>
export default {
  name: "Faq",
  data() {
    return {
      text: {
        title: "FAQ",
        text: "No Information available for now",
      },
      cookiesObject: "",
    };
  },
  async mounted() {
    var cookiesObject = document.cookie
      .split(";")
      .map((cookie) => cookie.split("="))
      .reduce(
        (accumulator, [key, value]) => ({
          ...accumulator,
          [key.trim()]: decodeURIComponent(value),
        }),
        {}
      );
    this.cookiesObject = cookiesObject;

    var resp = await fetch(
      "https://sportapi.zuniac.com/general/page?languageId=" +
        (cookiesObject.langId ? cookiesObject.langId : 0) +
        "&link=faq&portalId=" +
        (cookiesObject.portalId ? cookiesObject.portalId : 0)
    );
    var data = await resp.json();
    console.log(data);

    if (data.code == 200) {
      this.text = data.page;
    } else {
      this.text.title = "FAQ";
      this.text.text = "No Information available for now";
    }
  },
};
</script>

<style scoped>
</style>
